// Approve.js
import React, { Component } from 'react';
import '../css/Approve.css';  // Optional: For custom styling

class Approve extends Component {
  render() {
    return (
        <div className="approve-container">
        <h1 className="approval-heading">Your Request is Approved</h1>
        <br />
        <p className="page-description">
          Best of luck! For any further assistance, please follow OKAS Support or write to us at support@okas.ai.
        </p>
      </div>
    );
  }
}

export default Approve;
